import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import timeUtils from '@/utils/time.js';
export default {
  props: {
    text: String,
    onSaleTime: Number,
    isAnimated: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      showDate: false
    };
  },
  computed: {
    onSaleTimeInfo: function onSaleTimeInfo() {
      var onSaleTime = this.onSaleTime;
      var _timeUtils$formatOnSa = timeUtils.formatOnSaleTime(onSaleTime),
        onSaleTimeInfo = _timeUtils$formatOnSa.onSaleTimeInfo;
      return onSaleTimeInfo;
    }
  },
  // mounted () {
  //   setTimeout( () => {
  //     this.show()
  //   }, 3000 )
  //   setTimeout( () => {
  //     this.hide()
  //   }, 5000 )
  // },
  methods: {
    onClick: function onClick() {
      this.$emit('buttonClick');
    },
    pad: function pad(time) {
      return timeUtils._pad(time);
    },
    hide: function hide() {
      var isAnimated = this.isAnimated;
      if (!isAnimated) {
        return;
      }
      this.showDate = false;
      this.$nextTick(function () {
        var textElement = document.getElementById('detail-animate-text');
        textElement.animate([{
          top: '10%'
        }, {
          top: '22%'
        }], {
          fill: 'forwards',
          duration: 800
        });
      });
    },
    show: function show() {
      var isAnimated = this.isAnimated;
      if (!isAnimated) {
        return;
      }
      var self = this;
      var textElement = document.getElementById('detail-animate-text');
      var animation = textElement.animate([{
        top: '22%'
      }, {
        top: '10%'
      }], {
        fill: 'forwards',
        duration: 800
      });
      animation.onfinish = function () {
        self.showDate = true;
      };
    }
  }
};